var _path, _polygon;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCssicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#264DE4",
    d: "M24.975,49.997L6.971,45L2.959,0.002h44.083l-4.017,44.991L24.975,49.997L24.975,49.997z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "30.542,9.201 25.001,9.201 25.001,9.2 11.162,9.2 11.663,14.719 21.75,14.719 21.75,14.72   24.982,14.72 30.542,14.72 32.758,14.72 32.254,20.371 31.777,20.371 25.001,20.371 24.982,20.371 16.375,20.371 12.156,20.371   12.65,25.891 16.375,25.891 24.982,25.891 25.001,25.891 31.777,25.891 31.137,33.047 28.388,33.789 28.388,33.789 25.001,34.704   25.001,34.703 24.981,34.709 22.536,34.051 18.831,33.05 18.438,28.65 12.897,28.65 13.67,37.314 24.975,40.455 25,40.445   25,40.444 36.295,37.313 36.377,36.379 37.674,21.852 37.811,20.371 38.807,9.201 "
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssicon);
export default __webpack_public_path__ + "static/media/cssicon.300d50544a67631b84874286b41045df.svg";
export { ForwardRef as ReactComponent };